import ResourceService from "./resource.service";

class CompanyService extends ResourceService {
  static get resource() {
    return "company";
  }
}

export default CompanyService;
